import { type ServiceAppState, TOKEN_SCOPE } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { getRequestUrlData } from '../../utils/getRequestUrlData';

import type { Guard } from '../../types';

/**
 * 도메인 ID를 결정하는 Guard
 * @description
 * 접속 URL의 query string에 domainId가 있을 경우 해당 domain id를 사용합니다.
 *   (e.g. 다른 사용자로부터 다른 도메인으로 접속한 콘솔 링크를 공유받은 경우)
 * 접속 URL의 query string에 domainId가 없을 경우 사용자 정보에서 얻은 domainId를 사용합니다.
 * 사용자 정보는 generateBaseTokenGuard에서 setting된 것을 의미합니다.
 * searchParamsDomainId 가 존재하는 경우, validateQueryGuard에서 검증된 값이므로 그대로 사용합니다.
 */
export const determineDomainGuard: Guard<ServiceAppState> = async ({ state, context }) => {
  const { scope, domainId } = state;

  // domain scope 서비스가 아니라면 필요없는 로직이므로 바로 가드 종료
  if (scope !== TOKEN_SCOPE.DOMAIN) return { status: STATUS_CODE.OK };

  const { domainId: searchParamsDomainId } = getRequestUrlData(context);
  const targetDomainId = searchParamsDomainId || domainId;

  return { status: STATUS_CODE.OK, domainId: targetDomainId };
};

determineDomainGuard.displayName = 'determineDomainGuard';
